import { AuthConfig } from 'angular-oauth2-oidc';
import { ENV } from '../../environments/environment';

export const oauthServerConfig: AuthConfig = {
  issuer: ENV.oauthHost,
  loginUrl: ENV.oauthHost + '/as/authorization.oauth2',
  logoutUrl: ENV.casHost + '/cas/logout' + '?service=' + window.location.origin,
  tokenEndpoint: ENV.oauthHost + '/as/token.oauth2',
  userinfoEndpoint: ENV.oauthHost + '/idp/userinfo.openid',

  redirectUri: window.location.origin + '/index.html',

  clientId: 'caps_oauth_client',
  dummyClientSecret: '16lFeEjh0MzFRkTHVLIxywLWhKMiQ8lKdo2ViPhC2CcG92yXBJCcltuMzvlurP31',

  scope: 'auth-columbia profile openid email capsgroup',

  responseType: 'code',
  showDebugInformation: true,
  oidc: false,
  useSilentRefresh: false,
  sessionChecksEnabled: false,
  clearHashAfterLogin: false,
  disableAtHashCheck: true,
  skipIssuerCheck: true,
};
